import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
    templateUrl: './success-message.component.html',
    styleUrls: ['./success-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SuccessMessageComponent {
  constructor(private matSnackBarRef: MatSnackBarRef<SuccessMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public message: string) {
  }

  dismiss() {
    this.matSnackBarRef.dismiss();
  }
}
